import { Link } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export default function NotFound() {
  useDocumentTitle('页面不存在 - 风驰影院', '你访问的页面不存在或已被移除。');

  return (
    <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-200 text-primary-500">
        <i className="ri-movie-line text-4xl" />
      </span>
      <p className="mt-6 font-heading text-5xl font-extrabold text-foreground-950">404</p>
      <h1 className="mt-3 font-heading text-xl font-bold text-foreground-800">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移除。不如回到首页，继续发现精彩的影视作品与资讯吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-home-4-line text-lg" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex h-11 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
        >
          <i className="ri-movie-2-line text-lg" />
          浏览电影
        </Link>
      </div>
    </div>
  );
}